// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { AuditEvent, auditEventsResponseSchema } from '@/audit/api/types';

/**
 * Fetches audit events for a bundle.
 */
export async function getBundleAuditEvents(key: string): Promise<AuditEvent[]> {
  const url = `/v1/catalog/bundle/${key}/audit`;
  const response = await api.get(url);
  const result = await parseResponse(auditEventsResponseSchema, response.data, {
    schemaName: 'BundleAuditEvents',
    endpoint: url,
  });
  return result.events;
}
